/**
 * The cookie the boundary's session travels in.
 *
 * The backend reads it under the same name (`authn.HankoCookieName`), and
 * `/signout` expires it there. Written and expired here, attributes and all,
 * so the stand-in that sets it in development and the sign-out that clears it
 * cannot drift apart: an expiry with a different Path leaves the original in
 * place.
 */
export const sessionCookie = 'hanko'

const attributes = 'Path=/; SameSite=Lax'

/** Carries a session in this browser, as the boundary's own cookie would. */
export function holdSession(token: string): void {
  document.cookie = `${sessionCookie}=${token}; ${attributes}`
}

/** Stops this browser carrying a session. */
export function dropSession(): void {
  document.cookie = `${sessionCookie}=; ${attributes}; Max-Age=0`
}
